import templateUrl from "emun.auth/retailer-approval.htm";
import controller from "emun.auth/retailer-approval.controller";
import modals from "webmodals/modals";

export default {
  open(options) {
    console.debug(templateUrl, { templateUrl, options });
    return modals.open(
      Object.assign(
        {
          templateUrl,
          resolve: {
            options: () => options,
          },
          bindToController: true,
          controller,
          controllerAs: "$ctrl",
          size: "lg",
        },
        (options || {}).modal
      )
    ).result;
  },
};
